export function getChartSeriesColors(theme: CSSStyleDeclaration): string[] {
  return Array.from({ length: 20 }, (_, index) =>
    theme.getPropertyValue(`--chart-series-${index + 1}`).trim());
}
